<app-loading *ngIf="isLoading"></app-loading>

<div *ngIf="!isLoading" class="compare-group-detail">
  <h1 class="compare-group-page-title">
    <ng-container *ngIf="isEditing">Edit Benchmark</ng-container>
    <ng-container *ngIf="!isEditing">Create Benchmark</ng-container>
  </h1>
  <div class="control-bar">
    <div class="control-bar-row">
      <div class="control-group-name">
        <span>
          Benchmark Name: <input 
                                type="text"
                                class="control-group-name"
                                [ngClass]="{'control-group-name-warning': noNameGiven === true}"
                                [(ngModel)]="compareGroupDescription"
                                placeholder="Enter Benchmark Name"
                                (ngModelChange)="isDirty = true"
                                (focus)="onCompareGroupInputFocus()"
                                maxlength="250" 
                              />
        </span>
        <button mat-stroked-button color="primary" class="left-button" (click)="onSave(false)">
          <ng-container *ngIf="isEditing">Update</ng-container>
          <ng-container *ngIf="!isEditing">Create</ng-container>
        </button>
      </div>
      <button *ngIf="isEditing" mat-stroked-button color="primary" class="left-button" (click)="onSave(true)">
        Save As New
      </button>
      <button mat-stroked-button color="primary" class="right-button" (click)="onReturn()">Back</button>
    </div>

    <div class="control-bar-row">
      <mat-form-field class="search-field">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search..." appearance="outline">
        <button mat-button matPrefix>
          <mat-icon class="search-hourglass">search</mat-icon>
        </button>
      </mat-form-field>

      <button mat-stroked-button color="primary" class="right-button" (click)="showColumnList = !showColumnList">
        Add/Remove Columns
      </button>

      <button mat-stroked-button color="primary" class="right-button" (click)="showSelected = !showSelected">
        <ng-container *ngIf="!showSelected">Show Selected Organizations</ng-container>
        <ng-container *ngIf="showSelected">Hide Selected Organizations</ng-container>
      </button>
    </div>
  </div>

  <div class="compare-list-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="compareGroupMember">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="select-all-container">
            <mat-checkbox (click)=onSelectAll($event)></mat-checkbox>
            <span style="margin-left: 5px;">{{ rowToName('compareGroupMember') }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox 
            [(ngModel)]="row.compareGroupMember" 
            [checked]="row.compareGroupMember"
            (change)="updateGroupMembers()"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="orgName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('orgName') }}</th>
        <td mat-cell class="org-name-column" *matCellDef="let row"> {{ row.orgName }} </td>
      </ng-container>
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('region') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.region }} </td>
      </ng-container>
      <ng-container matColumnDef="accreditation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('accreditation') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.accreditation }} </td>
      </ng-container>
      <ng-container matColumnDef="unionized">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('unionized') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.unionized }} </td>
      </ng-container>
      <ng-container matColumnDef="magnetRecognition">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('magnetRecognition') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.magnetRecognition }} </td>
      </ng-container>
      <ng-container matColumnDef="pathwayToExcellence">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('pathwayToExcellence') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.pathwayToExcellence }} </td>
      </ng-container>
      <ng-container matColumnDef="numberOfCohortPerYear">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('numberOfCohortPerYear') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.numberOfCohortPerYear }} </td>
      </ng-container>
      <ng-container matColumnDef="numberOfFTEs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('numberOfFTEs') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.numberOfFTEs }} </td>
      </ng-container>
      <ng-container matColumnDef="ratioOfFacilitatorPerResident">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('ratioOfFacilitatorPerResident') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.ratioOfFacilitatorPerResident }} </td>
      </ng-container>
      <ng-container matColumnDef="durationOfSeminar">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('durationOfSeminar') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.durationOfSeminar }} </td>
      </ng-container>
      <ng-container matColumnDef="programDelivery">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('programDelivery') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.programDelivery }} </td>
      </ng-container>
      <ng-container matColumnDef="clinicalReflection">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('clinicalReflection') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.clinicalReflection }} </td>
      </ng-container>
      <ng-container matColumnDef="periodDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('periodDate') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.periodDate | date: 'yyyy' }} </td>
      </ng-container>
      <!-- <ng-container matColumnDef="frequencyOfSeminars">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('frequencyOfSeminars') }}</th>
          <td mat-cell *matCellDef="let row"> {{ seminarFrequency(row.frequencyOfSeminars) }} </td>
      </ng-container> -->
      <ng-container matColumnDef="averageDailyCensus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('averageDailyCensus') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.averageDailyCensus }} </td>
      </ng-container>
      <ng-container matColumnDef="teachingStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('teachingStatus') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.teachingStatus }} </td>
      </ng-container>
      <ng-container matColumnDef="hospitalLocation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('hospitalLocation') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.hospitalLocation }} </td>
      </ng-container>
      <ng-container matColumnDef="criticalAccessHospital">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('criticalAccessHospital') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.criticalAccessHospital }} </td>
      </ng-container>
      <ng-container matColumnDef="hospitalSize">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('hospitalSize') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.hospitalSize }} </td>
      </ng-container>
      <ng-container matColumnDef="numberOfNewRNGraduatesHired">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('numberOfNewRNGraduatesHired') }}</th>
        <!--<td mat-cell *matCellDef="let row" ngClass="centered-column">{{ row.numberOfNewRNGraduatesHired }}</td>-->
        <td mat-cell *matCellDef="let row" class="column-centered">{{ row.numberOfNewRNGraduatesHired }}</td>
      </ng-container>
      <ng-container matColumnDef="medicalSchoolAffiliationReportedToAMA">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('medicalSchoolAffiliationReportedToAMA') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.medicalSchoolAffiliationReportedToAMA }} </td>
      </ng-container>
      <ng-container matColumnDef="primaryService">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('primaryService') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.primaryService }} </td>
      </ng-container>
      <ng-container matColumnDef="rnDirectPatientCareFTE">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('rnDirectPatientCareFTE') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.rnDirectPatientCareFTE }} </td>
      </ng-container>
      <ng-container matColumnDef="totalBirthsExcludingFetalDeaths">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('totalBirthsExcludingFetalDeaths') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.totalBirthsExcludingFetalDeaths }} </td>
      </ng-container>
      <ng-container matColumnDef="totalOutpatientVisits">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('totalOutpatientVisits') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.totalOutpatientVisits }} </td>
      </ng-container>
      <ng-container matColumnDef="parentSystems">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('parentSystems') }}</th>
        <td mat-cell *matCellDef="let row">
          <div *ngFor="let parentSystem of row.parentSystems; let lastItem = last">
            <span>{{parentSystem.replace('*','')}}</span><span *ngIf="!lastItem">,</span>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="bedsTotalFacility">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('bedsTotalFacility') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.bedsTotalFacility }} </td>
      </ng-container>
      <ng-container matColumnDef="activationDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('activationDate') }}</th>
        <td mat-cell *matCellDef="let row" class="column-centered"> {{ row.activationDate | date: 'yyyy'  }} </td>
      </ng-container>
      <ng-container matColumnDef="orgClassificationType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('orgClassificationType') }}</th>
        <td mat-cell *matCellDef="let row"> {{ row.orgClassificationType }} </td>
      </ng-container>

      <!-- <ng-container matColumnDef="orgID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('orgID') }}</th>
          <td mat-cell *matCellDef="let row"> {{ row.orgID }} </td>
      </ng-container>
      <ng-container matColumnDef="shortName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rowToName('shortName') }}</th>
          <td mat-cell *matCellDef="let row"> {{ row.shortName }} </td>
      </ng-container>      -->

      <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>

      <tr mat-row *matRowDef="
        let row;
        let even = even
        columns: getDisplayedColumns();"
        [ngClass]="{grayRow: even}"
      ></tr>

    </table>

    <!-- <mat-paginator
      [length]="paginationLength"
      [pageSize]="paginationSize"
      [pageSizeOptions]="paginationSizeOptions"
    ></mat-paginator> -->

    <app-no-data 
      *ngIf="isListEmpty" 
      noDataTitle="There are no data to show"
      noDataSubTitle="There are no members for your selected organization"
    ></app-no-data>
  </div>

  <div *ngIf="showColumnList">
    <div class="screen-overlay" (click)="showColumnList = !showColumnList"></div>
    <div class="overlay-container column-list-container">
      <div class="column-list-top">
        <div class="column-list-title">Edit Columns</div>
      </div>

      <div class="column-list">
        <mat-selection-list>
          <ng-container *ngFor="let column of displayedColumns; let even = even;">
            <mat-list-option 
              [selected]="column.show"
              (click)="onSetColumn(column.def)"
              checkboxPosition="before"
              [ngClass]="{grayRow: even}"
              *ngIf="column.def != 'compareGroupMember'"
            >
              {{ column.label }}
            </mat-list-option>
          </ng-container>
        </mat-selection-list>
      </div>

      <div class="column-list-bottom">
        <button mat-stroked-button color="primary" class="column-list-button" (click)="updateShownColumns()">Save Changes</button>
        <button mat-stroked-button color="primary" class="column-list-button" (click)="showColumnList = !showColumnList">Cancel</button>
      </div>
    </div>
  </div>

  <div *ngIf="showSelected">
    <div class="screen-overlay" (click)="showSelected = !showSelected"></div>
    <div class="overlay-container">

      <div class="selected-list-title">
        <span>Selected Members</span>
        <span>
          <mat-icon (click)="showSelected = !showSelected">close</mat-icon>
        </span>
      </div>

      <ng-template *ngIf="getSelectedMembers().length > 0; then membersExist; else listEmpty"></ng-template>

      <ng-template #membersExist>
        <div class="selected-list">
          <mat-selection-list #selectedMembers>
            <mat-list-option 
              *ngFor="let selected of getSelectedMembers(); let even = even;"
              checkboxPosition="before"
              value="{{selected.orgID}}"
              [ngClass]="{grayRow: even}"
              [selected]="true"
            >
              {{selected.orgName}}
            </mat-list-option>
          </mat-selection-list>
        </div>

        <div class="selected-list-footer">
          <button mat-stroked-button color="primary" (click)="showSelected = !showSelected" class="selected-list-button">Close</button>
          <button mat-stroked-button color="primary" (click)="removeUnselected(selectedMembers.selectedOptions.selected)" class="selected-list-button">Update Selected List</button>
        </div>
      </ng-template>

      <ng-template #listEmpty>
        <div class="selected-list-empty">There are no members selected.</div>

        <div class="selected-list-footer">
          <button mat-stroked-button color="primary" (click)="showSelected = !showSelected" class="selected-list-button">Close</button>
        </div>
      </ng-template>
    </div>
  </div>
  <app-alert 
    *ngIf="showAlert" 
    header="Notice" 
    message="{{alertMessage}}" 
    (closeAlert)="closeAlert()"
    [confirm]="alertIsConfirm" 
    (alertConfirm)="alertConfirm($event)"
  ></app-alert>
</div>